import { useFrame } from "@react-three/fiber";
import { useCallback } from "react";
export const useUpdate = (callback, renderPriority) => {
    const newCallback = useCallback((state, delta, frame) => {
        callback(state, Math.min(delta, 1), frame);
    }, [callback]);
    useFrame(newCallback, renderPriority);
};
//# sourceMappingURL=UseUpdate.js.map